import $ from 'jquery';
const EventEmitter = require( 'eventemitter3' );

export class SsMount extends EventEmitter {
  constructor ( elm ) {
    super();
    this.elm = elm;
    this.$ = $( elm );
  }
}
